import { EventBus, Events } from "jiffy-store";
import initSampleInfoTooltips from "components/jiffy/sample-info-tooltip/sample-info-tooltip";

const initColorChangeHandler = () => {
  EventBus.on(Events.PRODUCT_COLOR_SELECTED, () => {
    // Build redirect URL with sample=true parameter
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set("sample", "true");
    const nextPage = encodeURIComponent(currentUrl.pathname + currentUrl.search);

    // Update sample link for logged-in users only
    const $sampleLink = document.querySelector(".js-sample-request-link");
    if ($sampleLink && !$sampleLink.classList.contains("js-sign-in-modal-toggle")) {
      // Only update if it's NOT a guest user (guest users have js-sign-in-modal-toggle class)
      const url = new URL($sampleLink.href, window.location.origin);
      url.searchParams.set("ac", new URLSearchParams(window.location.search).get("ac"));
      // eslint-disable-next-line no-param-reassign
      $sampleLink.href = url.pathname + url.search;
    }

    // Update sign-in modal form action
    const $signInForm = document.querySelector(".js-sign-in-modal-form-in");
    if ($signInForm) {
      $signInForm.action = $signInForm.action.replace(
        /(redirect_to=)([^&]*)/gi,
        `redirect_to=${nextPage}`
      );
    }

    // Update sign-up modal form action
    const $signUpForm = document.querySelector(".js-sign-in-modal-form-up");
    if ($signUpForm) {
      $signUpForm.action = $signUpForm.action.replace(
        /(redirect_to=)([^&]*)/gi,
        `redirect_to=${nextPage}`
      );
    }
  });
};

let isInitProductRequestSampleInited = false;

const initProductRequestSample = () => {
  if (!isInitProductRequestSampleInited) {
    isInitProductRequestSampleInited = true;
    initSampleInfoTooltips();
    initColorChangeHandler();
  }
};

export default initProductRequestSample;
